import * as React from "react";
import { SVGProps } from "react";
const SvgRadioCheckboxTick = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.942 23.652c-.2 0-.403-.06-.579-.185l-7.35-5.227a1.001 1.001 0 0 1 1.16-1.63l6.535 4.647L23.584 8.78a1 1 0 1 1 1.63 1.16l-9.456 13.292a1 1 0 0 1-.695.413l-.12.007h-.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRadioCheckboxTick;
